import AddTeacherModal from "./AddTeacherModal";

export default AddTeacherModal;
